import { Toast } from '@components';
import { useToast } from '@hooks';
import { Collapse, Stack } from '@mui/material';

export const ToastProvider = () => {
  const { toastList, hideToast } = useToast();
  return (
    <Stack
      sx={{
        position: 'fixed',
        top: { xs: 64, md: 80 },
        right: 8,
        alignItems: 'flex-end',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      {toastList.map((item, key) => (
        <Collapse key={key} in={item.isVisible}>
          <Toast
            key={key}
            {...item}
            open={item.isVisible}
            onClose={() => hideToast(item.id)}
          ></Toast>
        </Collapse>
      ))}
    </Stack>
  );
};
